import { LossAndDamageClaimsTypes } from './LossAndDamageClaimsTypes';

export const setLossAndDamageFilters = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_CLAIMS_FILTERS,
});
export const setLossAndDamageFilterType = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_FILTER_TYPE,
});
export const setSelectedLADClaims = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_SELECTED_CLAIMS,
});
export const setLADClaimEditDrawer = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_CLAIM_EDIT_DRAWER,
});
export const setSelectedClaimKey = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_SELECTED_CLAIM_KEY,
});

export const setLDClaimViewType = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE,
});
export const setLDClaimViewTypeInitial = (payload) => ({
  payload,
  type: LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL,
});
